import {Component, inject, OnInit} from '@angular/core';
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ManageEmailModalComponent} from "./manage-email-modal/manage-email-modal.component";
import {ArbitraryEmailResource} from "../../../../service/ArbitraryEmailResource";
import {ArbitraryEmailDto} from "../../../../../generated-model/model";
import {from} from "rxjs";
import {filter} from "rxjs/operators";
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-manage-email',
  standalone: true,
  imports: [
    NotFoundComponent,
    NgForOf
  ],
  templateUrl: './manage-email.component.html',
  styleUrl: './manage-email.component.scss'
})
export class ManageEmailComponent implements OnInit {
  modalService = inject(NgbModal);
  arbitraryEmailResource = inject(ArbitraryEmailResource);

  items: ArbitraryEmailDto[] = [];
  ngOnInit(): void {
   this.search()
  }

  search() {
    this.arbitraryEmailResource.findAllEmail().subscribe(e => {
      this.items = e;
    });
  }

  manageEmailModal(item: ArbitraryEmailDto) {
    const modalRef = this.modalService.open(ManageEmailModalComponent, {
      size: "xl",
      windowClass: 'custom-modal-content',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.item = item;
    from(modalRef.result).pipe(filter(e => !!e))
      .subscribe(e => {
        this.search()
      });
  }
}
